import { useMainSelector } from '../../useMainSelector';

export const useTimezone = () => {
  const {
    settings: { timezone },
  } = useMainSelector();

  return {
    timezone,
  };
};
